const _TYPE_PRODUCT = 'product';
const _TYPE_PRODUCT_FILTER = 'product-filter';
const _TYPE_FILTER_ATTRIBUTE = 'attribute';
const _TYPE_FILTER_FEATURE = 'feature';
export const _NAME_FEATURE_CARACT = 'Caractéristique miniature';
export const _NAME_NUMBER_PIECES = 'Nombre de pièces par lot';

/**
 *
 * @returns {string}
 */
export const getTypeProduct = () => {
    return _TYPE_PRODUCT;
}
/**
 *
 * @returns {string}
 */
export const getTypeProductFilter = () => {
    return _TYPE_PRODUCT_FILTER;
}

/**
 *
 * @returns {string}
 */
export const getTypeFilterAttribute = () => {
    return _TYPE_FILTER_ATTRIBUTE;
}
/**
 *
 * @returns {string}
 */
export const getTypeFilterFeature = () => {
    return _TYPE_FILTER_FEATURE;
}




// WEBPACK FOOTER //
// ./src/api/type.js